import React from 'react';
import _ from 'lodash';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';
import TableRowComponent from '../../shared_components/TableRowComponent';
import TableRowRiskClassReductionComponent from './TableRowRiskClassReductionComponent';
import TableRowSubRiskClassReductionComponent from './TableRowSubRiskClassReductionComponent';

@observer
class TableBodyRiskClassReductionComponent extends React.Component {
  render() {
    const { rowData, columnNames, extraRowData, addNumberFormattingByMonth } = this.props;

    let currentMonth = 1;
    let prevMonth = 1;

    /* Standard row for each month beginning at current date  */
    const rows = rowData.map((row, i) => {
      const standardRow = (
        <TableRowComponent
          row={row}
          // eslint-disable-next-line react/no-array-index-key
          key={i}
          columnNames={columnNames}
        />
      );

      let component = standardRow;
      currentMonth = row.month;

      /* Between range prevMonth && currentMonth */
      const rangeBetweenPrevAndCurMonths = _.range(prevMonth, currentMonth);

      const riskClassReductionMonth = extraRowData.find((extraRow) => {
        const rowWithinRange = rangeBetweenPrevAndCurMonths.find((month) => {
          let monthWithinRange;
          if (extraRow.month > 1 && extraRow.month === month) {
            monthWithinRange = month;
          }

          return monthWithinRange;
        });

        return rowWithinRange;
      });

      prevMonth = row.month;

      /* Set component to default row for each year */
      component = ([standardRow]);

      if (riskClassReductionMonth && row.month !== 1) {
        const formattedMonth = addNumberFormattingByMonth(riskClassReductionMonth);
        component = ([
          <TableRowRiskClassReductionComponent
            row={formattedMonth}
            columnNames={columnNames}
          />,
          <TableRowSubRiskClassReductionComponent
            row={formattedMonth}
            columnNames={columnNames}
          />,
          standardRow,
        ]);
      }

      return component;
    });

    return (
      <tbody>
        {rows}
      </tbody>
    );
  }
}

TableBodyRiskClassReductionComponent.propTypes = {
  extraRowData: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
  rowData: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
  columnNames: PropTypes.arrayOf(PropTypes.string),
  addNumberFormattingByMonth: PropTypes.func,
};

TableBodyRiskClassReductionComponent.defaultProps = {
  extraRowData: [],
  rowData: [],
  columnNames: [],
  addNumberFormattingByMonth: () => {},
};

export default inject('CalculationOutputData')(TableBodyRiskClassReductionComponent);
